import { useQuery } from '@tanstack/react-query';
import { getOptionGroups } from '../../api/apiOptionGroups';
import i18next from 'i18next';

/**
 * Hook to fetch option groups with pagination and filters
 */
export const useGetOptionGroups = (params = {}) => {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ['optionGroups', params, i18next.language],
        queryFn: () => getOptionGroups(params),
        retry: false,
    });

    return {
        optionGroups: data?.data?.data || [],
        meta: data?.data?.meta || {},
        error,
        isLoading,
        refetch
    };
};
